import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Palette } from 'Palette';
import { RADIUS } from 'DesignTokens';
import Address from '../../../models/Address';
import { asFloat } from '../../../services/ValueChecker';
import AddressMapPreview from './AddressMapPreview';

export interface AddressListRowProps {
  address: Address;
  tone?: 'tone1' | 'white';
  onRemove: () => void;
}

const AddressListRow: React.FC<AddressListRowProps> = ({ address, tone = 'white', onRemove }) => {
  const [mapOpen, setMapOpen] = useState(false);

  const lat = asFloat(address.latitude);
  const lng = asFloat(address.longitude);
  const hasCoordinates = !!lat && !!lng;

  return (
    <Box
      sx={{
        backgroundColor: tone === 'white' ? '#FFFFFF' : Palette.tone1.background,
        border: `1px solid ${Palette.default.border}`,
        borderRadius: RADIUS.sectionChild,
        padding: '0.75rem 1rem',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            sx={{ fontWeight: 600, fontSize: '0.875rem', color: Palette.tone1.text }}
            noWrap
          >
            {address.streetAddress}
          </Typography>
          <Typography sx={{ fontSize: '0.75rem', color: Palette.default.disabledText }} noWrap>
            {address.suburb}, {address.state} {address.postcode}
          </Typography>
        </Box>
        {hasCoordinates && (
          <Tooltip title={mapOpen ? 'Hide map' : 'Show map'}>
            <IconButton
              size="small"
              onClick={() => setMapOpen((prev) => !prev)}
              sx={{ color: mapOpen ? Palette.default.buttonBg : Palette.default.disabledText }}
            >
              <MapOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        <Tooltip title="Remove address">
          <IconButton size="small" onClick={onRemove} sx={{ color: Palette.danger.text }}>
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      {hasCoordinates && (
        <AddressMapPreview lat={lat} lng={lng} fullAddress={address.fullAddress} open={mapOpen} />
      )}
    </Box>
  );
};

export default AddressListRow;
